import { config } from '../../core';
import Lottie from '../../modules/Lottie';

export default class Hero extends Lottie {
  constructor() {
    super();
    this.$container = document.querySelector('[data-kv-story]')
    if(!this.$container) return;
    this.$hero = document.querySelector('[data-hero]')
    this.$opening = document.querySelector('[data-opening]')
    this.$openingLogo = document.querySelector('[data-animate-id="logo"]')
    this.$heading = [...document.querySelectorAll('[data-hero-el="heading"]')];
    this.$story = document.querySelector('[data-story]')
    this.$bg = document.querySelector('[data-hero-el="bg"]')
    this.$ill = [...document.querySelectorAll('[data-hero-el="ill"]')];
    this.$scrollDown = document.querySelector('[data-hero-el="scroll-down"]')
    this.lottieItems = [this.$openingLogo];
    this.sessionStorage = sessionStorage.getItem('opening')
    this.mobile = window.innerWidth < config.viewport.sm
    this.setup();
    window.addEventListener('load', () => this.init());
  }

  init() {
    this.opening();
    this.onScroll();
  }

  setup() {
    gsap.set(this.$container, { 'clip-path': this.mobile ? 'inset(0 3.333vw)' : 'inset(0 50px)' })
    gsap.set(this.$bg, { autoAlpha: 0, y: 50, 'clip-path': this.mobile ? 'inset(0vw 3.333vw round 8vw 8vw 0 0)' : 'inset(0 50px round 30px 30px 0 0)' })
    gsap.set(this.$heading, { autoAlpha: 0, yPercent: 80 })
    gsap.set(this.$scrollDown, { autoAlpha: 0, yPercent: -25 })
    gsap.set(this.$story, { autoAlpha: 0, y: 50 })
  }

  opening() {
    if (this.sessionStorage) {
      gsap.to(this.$opening, {
        autoAlpha: 0,
        duration: 0,
        ease: 'none',
      })
      setTimeout(() => this.opening02(), 400);
      return;
    }

    this.createLottie(this.lottieItems);
    this.animations['logo'].lottie.play()
    this.animations['logo'].lottie.onComplete = () => {
      gsap.to(this.$opening, {
        autoAlpha: 0,
        duration: 0.4,
        ease: 'none',
        delay: 0.1,
        onComplete: () => {
          setTimeout(() => {
            this.opening02();
            this.$opening.remove();
            sessionStorage.setItem('opening', 'complete');
          }, 100);
        }
      })
    }
  }

  opening02() {
    const openingTl = gsap.timeline();
    openingTl
      .to(this.$heading, {
        autoAlpha: 1,
        yPercent: 0,
        duration: 1,
        ease: 'power4.out',
        stagger: { 
          each: 0.15,
        },
      })

      .to([this.$bg, this.$story], {
        autoAlpha: 1,
        y: 0,
        duration: 1,
        ease: 'power4.out',
        onStart: () => {
          setTimeout(() => {
            this.$container.style.backgroundColor = '#e6f7fa';         
          }, 50);
        }
      }, '-=0.75')

      .to(this.$scrollDown, {
        autoAlpha: 1,
        yPercent: 0,
        duration: 0.5,
        ease: 'circ.out',
      }, '-=0.4')
  }

  onScroll() {
    gsap.fromTo(this.$container, {
      'clip-path': this.mobile ? 'inset(0 3.333vw)' : 'inset(0 50px)',
    }, {
      'clip-path': this.mobile ? 'inset(0 0vw)' : 'inset(0 0px)',
      ease: 'power1',
      scrollTrigger:{
        trigger: this.$hero,
        start: '-65px top',
        end: 'bottom 50%',
        scrub: 1.5,
      }
    })

    gsap.fromTo(this.$bg, {
      'clip-path': this.mobile ? 'inset(0 3.333vw round 8vw 8vw 0 0)' : 'inset(0 50px round 30px 30px 0 0)',
    }, {
      'clip-path': this.mobile ? 'inset(0 0vw round 0vw 0vw 0 0)' : 'inset(0 0px round 0px 0px 0 0)',
      ease: 'power1',
      scrollTrigger:{
        trigger: this.$hero,
        start: '-65 top',
        end: 'bottom 50%',
        scrub: 1.5,
      }
    })

    this.$ill.forEach(ill => {
      gsap.set(ill, { yPercent: ill.dataset.startY })
      gsap.to(ill, {
        yPercent: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: this.$hero,
          start: '-65px top',
          end: 'bottom top',
          scrub: 1,
        },
      });
    });
  }
}
